/**
 * Anzeige- und Aktionsregeln fuer Angebote (TQ #960).
 * ERPNext-Status -> Kundentext: Open = Ausstehend, Ordered = Angenommen, Lost = Abgelehnt.
 * Open mit valid_till in der Vergangenheit = Abgelaufen, ohne Annehmen/Ablehnen.
 */
export type QuotationTone = 'pending' | 'accepted' | 'declined'

const LABELS: Record<string, { label: string; tone: QuotationTone }> = {
  Open: { label: 'Ausstehend', tone: 'pending' },
  Ordered: { label: 'Angenommen', tone: 'accepted' },
  Lost: { label: 'Abgelehnt', tone: 'declined' },
  Expired: { label: 'Abgelaufen', tone: 'declined' },
}

/** valid_till (YYYY-MM-DD) gilt bis einschliesslich, also bis Tagesende lokal (wie deadline() in reportFeedback). */
function validUntil(validTill: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(validTill)
  if (!m) return null
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59)
}

/** Open mit abgelaufenem valid_till gilt als abgelaufen (TQ #960). Unlesbares Datum: null. */
function openExpired(validTill: string | null | undefined, now: Date): boolean | null {
  if (!validTill) return false
  const d = validUntil(validTill)
  if (d === null) return null
  return now.getTime() > d.getTime()
}

export function quotationStatus(
  status: string,
  validTill?: string | null,
  now: Date = new Date(),
): { label: string; tone: QuotationTone } {
  if (status === 'Open' && openExpired(validTill, now) === true) return LABELS.Expired
  return LABELS[status] ?? { label: status, tone: 'pending' }
}

/**
 * Annehmen/Ablehnen nur im Status Open, wie die Cockpit-API es erzwingt, und nur solange
 * valid_till nicht abgelaufen ist (TQ #960). Unlesbares valid_till: fail-closed, keine Aktion.
 */
export function isActionable(status: string, validTill?: string | null, now: Date = new Date()): boolean {
  return status === 'Open' && openExpired(validTill, now) === false
}

export const REASON_MIN = 3
export const REASON_MAX = 500

export function reasonValid(reason: string): boolean {
  const n = [...reason.trim()].length
  return n >= REASON_MIN && n <= REASON_MAX
}
